import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ToursView from '../views/ToursView.vue'
import ToursDetailView from '../views/ToursDetailView.vue'
import DestinationView from '../views/DestinationView.vue'
import DestinationDetailView from '../views/DestinationDetailView.vue'
import AboutView from '../views/AboutView.vue'
import ContactView from '../views/ContactView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/tours/',
      name: 'tours',
      component: ToursView,
      alias: '/tours'
    },
    {
      path: '/tours/:category/:id/',
      name: 'tour-detail',
      component: ToursDetailView,
      alias: '/tours/:category/:id'
    },
    {
      path: '/destination/',
      name: 'destination',
      component: DestinationView,
      alias: '/destination'
    },
    {
      path: '/destination/:city/',
      name: 'destination-detail',
      component: DestinationDetailView,
      alias: '/destination/:city'
    },
    {
      path: '/about/',
      name: 'about',
      component: AboutView,
      alias: '/about'
    },
    {
      path: '/contact/',
      name: 'contact',
      component: ContactView,
      alias: '/contact'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  }
})

// Navigation guard for adding trailing slash for SEO consistency
router.beforeEach((to, from, next) => {
  // If the route doesn't end with a slash and doesn't have a file extension
  if (!to.path.endsWith('/') && !to.path.includes('.') && to.path.length > 1) {
    const { hash, params, query } = to;
    const nextRoute = { 
      path: `${to.path}/`, 
      hash, 
      params, 
      query 
    };
    
    // Redirect to the same route but with a trailing slash
    next(nextRoute);
  } else {
    next();
  }
});

export default router